import React from "react";
import { Briefcase } from "lucide-react";
import PaperCharm from "./PaperCharm";

export default function LoginScreen({ onLogin }) {
  return (
    <div className="halloween-theme november-theme tech-login h-screen bg-slate-50 flex flex-col items-center justify-center p-8 max-w-md mx-auto">
      <PaperCharm kind="lantern" className="login-story-charm" />
      <div className="tech-login-mark w-24 h-24 bg-white rounded-2xl shadow-lg flex items-center justify-center mb-8">
        <Briefcase className="w-12 h-12 text-blue-600" />
      </div>
      {/* 修改這裡的文字 */}
      <h2 className="text-3xl font-bold text-slate-800 mb-2">Urtale上班系統</h2>
      <p className="text-slate-500 mb-10 text-center">
        請使用您的 Google 帳號登入
        <br />
        以進行考勤紀錄
      </p>

      <button
        onClick={onLogin}
        className="tech-login-button w-full bg-white text-slate-700 border border-slate-300 py-4 rounded-xl font-bold shadow-sm hover:bg-slate-50 hover:shadow-md transition-all flex items-center justify-center gap-3"
      >
        <span>使用 Google 帳號登入</span>
      </button>
      <p className="mt-8 text-xs text-slate-400">系統版本 v3.1.0 (Modular)</p>
    </div>
  );
}
